// extracted by mini-css-extract-plugin
module.exports = {"SectionTitleContainer":"section-title_SectionTitleContainer__nViVV"};